var map = {
	"./CA/seal.png": 1488,
	"./CA/seal.svg": 1024,
	"./CA/seal_color.png": 1489,
	"./CA/seal_reversed.svg": 1025,
	"./CA/sos-logo.png": 1490,
	"./ID/seal.png": 1491,
	"./ID/seal.svg": 1026,
	"./ID/seal_color.png": 1492,
	"./ID/seal_reversed.svg": 1027,
	"./ID/sos-logo.png": 1493,
	"./MT/mt-sos-logo.png": 1494,
	"./MT/seal.png": 1495,
	"./MT/seal.svg": 1028,
	"./MT/seal_color.png": 1496,
	"./MT/seal_white.png": 1497,
	"./ND/seal.svg": 1029,
	"./SOS/seal.svg": 1030
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 214;



//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals ^\.\/.*$
// module id = 214
// module chunks = 0